import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import {
  partnerWalletStatement,
  partnerWalletStatementAll,
  partnerMyOwnWalletStatement,
  partnerMyOwnWalletStatementAll
} from "@/services/walletstatement.js";

@Module({
  namespaced: true
})
export default class WalletStatement extends VuexModule {
  //state

  walletStatementData = {};
  partnerWalletStatementData = {};

  //Action

  // partner my own //
  @Action
  public async fetchPartnerMyOwnWalletList(payload) {
    try {
      const data = await partnerMyOwnWalletStatement(payload);
      this.context.commit("setPartnerMyOwnWalletList", data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPartnerMyOwnWalletListAll() {
    try {
      const data = await partnerMyOwnWalletStatementAll();
      this.context.commit("setPartnerMyOwnWalletList", data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  // partner by tenant //
  @Action
  public async fetchWalletList(payload) {
    try {
      const data = await partnerWalletStatement(payload);
      this.context.commit("setWalletList", data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchWalletListAll(payload) {
    try {
      const data = await partnerWalletStatementAll(payload);
      this.context.commit("setWalletList", data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  //Mutation

  // partner my own //
  @Mutation
  public setPartnerMyOwnWalletList(data: any) {
    this.partnerWalletStatementData = data;
  }

  // partner by tenant //
  @Mutation
  public setWalletList(data: any) {
    this.walletStatementData = data;
  }

  //gatter
  // partner my own //
  get GetPartnerMyOwnWalletList() {
    return this.partnerWalletStatementData;
  }

  // partner by tenant //
  get GetWalletList() {
    return this.walletStatementData;
  }
}
